import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { jc } from 'utils';
import { getReviewsByScoreFilters, getReviewsSorting } from 'features/reviews/selectors';
import { REVIEWS_SORTING_SET, ReviewsSort } from 'features/reviews';
import { Dispatch } from 'redux';
import { ConnectedProps } from 'types/utils';
import { SortingDropdown, ReviewsWithScoreLabel } from './content-blocks';
import { ComponentCntr } from './styles';

type SortingDropdownWrapperMappedState = {
  filteredByScores: number[];
  sortedByLabel: string | null;
  sortedByValue: ReviewsSort;
};

type SortingDropdownWrapperProps = { isMobile?: boolean } & SortingDropdownWrapperMappedState &
  ConnectedProps<typeof mapDispatchToProps> &
  React.HTMLAttributes<HTMLElement>;

export const SortingDropdownWrapper: React.FC<SortingDropdownWrapperProps> = ({
  filteredByScores,
  sortedByLabel,
  sortedByValue,
  setReviewsSorting,
  isMobile,
  className = '',
  ...htmlProps
}) => {
  const onSortChange = useCallback(
    (selectedValue: string | string[] | null) => {
      if (typeof selectedValue === 'string') {
        setReviewsSorting(selectedValue as ReviewsSort);
      }
    },
    [setReviewsSorting],
  );

  return (
    <ComponentCntr data-qa="reviews-top-panel_mf-pdp" className={jc(className)} {...htmlProps}>
      {filteredByScores?.length > 0 && <ReviewsWithScoreLabel filteredByScores={filteredByScores} />}

      {typeof sortedByLabel === 'string' && (
        <SortingDropdown
          isMobile={isMobile}
          onSortChange={onSortChange}
          sortedByLabel={sortedByLabel}
          sortedByValue={sortedByValue}
          sortingLabelValuesMap={sortingLabelValuesMap}
        />
      )}
    </ComponentCntr>
  );
};

const sortingLabelValuesMap = new Map<ReviewsSort, string>([
  ['helpfulness:desc', 'Сначала полезные'],
  ['created_at:desc', 'Сначала новые'],
  ['created_at:asc', 'Сначала старые'],
]);

export const mapStoreToProps = (store: RootReducer): SortingDropdownWrapperMappedState => {
  const byScoreFilters = getReviewsByScoreFilters(store);
  const sortedByValue = getReviewsSorting(store);
  return {
    filteredByScores: byScoreFilters
      .filter((f) => f.isSet)
      .map((f) => f.score)
      .sort((a, b) => b - a),
    sortedByLabel: sortingLabelValuesMap.get(sortedByValue) ?? null,
    sortedByValue,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setReviewsSorting: (payload: ReviewsSort) => dispatch(REVIEWS_SORTING_SET(payload)),
});

export const ReviewsSorting = connect(mapStoreToProps, mapDispatchToProps)(SortingDropdownWrapper);
